/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
    IAgentPlugin,
    IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { SHARE_INVOICE } from "../graphql/shareInvoice.mutation";
import { VApplication } from "../../../application";
import { StorageModule } from "@vlinder-web/storage-module-react";

const log: any = LoggerModule?.getInstance();
const storageService = StorageModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IShareInvoiceMethods extends IPluginMethodMap {
    shareInvoice(args: any): Promise<any>;
}

export class ShareInvoiceService implements IAgentPlugin {
    readonly methods: IShareInvoiceMethods;

    constructor() {
        this.methods = {
            shareInvoice: this.shareInvoice.bind(this),
        };
    }

    async shareInvoice(args: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            // return {...config}
            if (client) {
                const res = await client.mutate({
                    mutation: SHARE_INVOICE,
                    variables: {
                        filter: {
                            _id: args?.payload?.id,
                        },
                    },
                    fetchPolicy: "no-cache",
                });
                if (res?.data) {
                    return {
                        ...res?.data,
                    };
                }
            }
        } catch (err: any) {
            let _display_message =
                err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.find((item: any) => item.extensions);
            if (_display_message?.extensions?.display_message) {
                throw Error(_display_message?.extensions?.display_message);
            }

            throw err;
        }
    }

}
